export const GET_COMMISSION_STATEMENT = gql`
    query commissionStatement($id: Int!) {
        commissionStatement(id: $id) {
            commissionStatement {
                id
                statementDate
                status
                commissionItems {
                    legalName
                    commissionItems {
                        commissionItem {
                            merchantId
                            merchant
                            serviceActivationDate
                            setupAndAccessory
                            monthly
                            totalCommission
                        }
                    }
                    partner
                    partnerOfPartner
                }
            }
            selfBillingInvoice {
                id
                createdAt
                partner {
                    id
                    firstName
                    lastName
                    business {
                        businessType
                        legalName
                    }
                    billingContactInformation
                }
            }
            partnerName
            totalSetupAndAccessory
            totalMonthly
            totalCommission
        }
    }
`;

export const GET_COMMISSION_STATEMENT_PDF = gql`
    query commissionStatementPDF($id: Int!) {
        commissionStatementPDF(id: $id) {
            pdfBytes
            downloadLink
        }
    }
`;

export const GET_COMMISSION_STATEMENT_FILTERS = gql`
    query commissionStatementFilters($commissionType: String!) {
        commissionStatementFilters(commissionType: $commissionType) {
            ids {
                id
                commissionStatementId
            }
            partnerNames
        }
    }
`;

export const GET_FILTERED_COMMISSION_STATEMENTS = gql`
    query filteredCommissionStatements($filters: FiltersInput!, $page: PageFilters) {
        filteredCommissionStatements(filters: $filters, page: $page) {
            id
            commissionStatementId
            partnerName
            totalCommission
            statementDate
            billingCycle
            selfBillingInvoice {
                id
                sageInvoiceNumber
            }
            status
            commissionType
        }
    }
`;
